// extracted by mini-css-extract-plugin
module.exports = {"DetailProductKey":"KeyInformation_DetailProductKey__DrtmU","PrivateTourLink":"KeyInformation_PrivateTourLink__XvRpK"};